import { createFeatureSelector } from '@ngrx/store';

import type { OrderState } from './order.state';

export const becomeACustomerOrderSelectorKey = 'order';

export const getOrderState = createFeatureSelector<OrderState>(
  becomeACustomerOrderSelectorKey
);
